import React from 'react';
import { useLocation } from "react-router-dom";
import { getBackToAppLink } from '../utils/utils';
import { useTranslation } from 'react-i18next';

const handleBackToApp = () =>  window.location = getBackToAppLink();

const ShowError = () => {

    const location = useLocation();
    const { t } = useTranslation();

    let notoken = false;
    if(location.state !== null && location.state !== "undefined" && location.state.noToken){
        notoken = location.state.noToken;
    }
    return (
        <div className="text-center">
            <div className="close-container">
                <div className="icon-prop close-img"></div>
            </div>
            {
            notoken ? 
                <h1 className="not-authorized" aria-describedby= {t('Sorry, you are not authorized to access this page')}>
                    {t('Sorry, you are not authorized to access this page')}
                </h1>
                :
                <>
                    <h1 className="not-authorized" aria-describedby={t("Sorry, we can’t add your card right now. Please try again later")}>
                        {t('Sorry, we can’t add your card right now')}
                    </h1>
                    <div>{t('Please try again later.')}</div>
                    <section className="card-buttons">
                        <button aria-label={t("Back to app")} onClick={handleBackToApp} className="zb-button zb-button-primary back-btn" >{t('Back to app')}</button>
                    </section>
                </> 
            }
        </div>
    );
  }
  export default ShowError;